import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { Application } from './Application';

@supertypeClass({ toClient: true })
export class SourceOfFunds extends Everything {
  @property({ getType: () => Application })
  application: Application;

  @property({
    comment: 'If the client is paying with funds from a retirement account',
  })
  payingWithRetirementAccount: boolean;

  @property({
    comment: 'If subject to 10% retirement account withdrawal penalty',
  })
  hasRetirementWithdrawalPenalty: boolean;

  @property({
    comment: 'If client has taken a hardship withdrawal in the past or will be subject to one for this policy',
  })
  hasRetirementHardshipWithdrawal: boolean;

  @property({
    comment: 'If client is subject to a surrender charge for the funds withdrawn to pay for this policy',
  })
  isSubjectToRetirementSurrenderCharge: boolean;

  @property({
    comment: 'surrender charge amount',
    rule: ['currency', 'numeric'],
    validate: 'isWithin(0,10000000)',
  })
  retirementSurrenderChargeAmount: number;

  @property({
    comment: 'Purpose of insurance policy',
    values: [],
  })
  retirementReasonForInsurance: string;

  @property({
    comment: 'Purpose of insurance policy if other is selected for retirementReasonForInsurance',
  })
  otherRetirementReasonForInsurance: string;

  static new(application) {
    return new SourceOfFunds().init(application);
  }

  init(application) {
    this.application = application;

    return this;
  }

  duplicateToNewSOF(sourceOfFunds) {
    sourceOfFunds.payingWithRetirementAccount = this.payingWithRetirementAccount;
    sourceOfFunds.hasRetirementWithdrawalPenalty = this.hasRetirementWithdrawalPenalty;
    sourceOfFunds.hasRetirementHardshipWithdrawal = this.hasRetirementHardshipWithdrawal;
    sourceOfFunds.isSubjectToRetirementSurrenderCharge = this.isSubjectToRetirementSurrenderCharge;
    sourceOfFunds.retirementSurrenderChargeAmount = this.retirementSurrenderChargeAmount;
    sourceOfFunds.retirementReasonForInsurance = this.retirementReasonForInsurance;
    sourceOfFunds.otherRetirementReasonForInsurance = this.otherRetirementReasonForInsurance;
  }
}
